const options = {
  Boot: {
    "Beach Bunny": {
      Watermelon: "#ff7282",
      "Peach Blanket": "#e79f7c",
      "Strawberry Lemonade": "#fdea51",
      "Sky Blue": "#bbe2ec",
      "Periwinkle Sunset": "#6970dd",
    },
    Boardwalk: {
      Red: "#c23940",
      Blue: "#029cbe",
      Purple: "#694d87",
      Pink: "#d8557f",
      Tan: "#c2a073",
      Black: "#13161b",
    },
    Impala: {
      "Living Coral": "#f17461",
      "Voltage Green": "#e5d758",
      Aqua: "#47c0b9",
      Purple: "#6a5798",
      Pink: "#e6b1b5",
      White: "#f3f4f1",
      Black: "#282325",
    },
    Lolly: {
      Poppy: "#e60327",
      Clementine: "#da792a",
      Pineapple: "#e9cb28",
      Honeydew: "#b5d399",
      Floss: "#c6e6e2",
      Jade: "#0aacac",
      "Pool Blue": "#0090c1",
      Taffy: "#502e80",
      Fuchsia: "#ca0180",
      Strawberry: "#fbb4b6",
      Black: "#111113",
    },
  },
  Laces: {
    "Beach Bunny": {
      Watermelon: "#64d752",
      "Peach Blanket": "#765d9f",
      "Strawberry Lemonade": "#f7c3a5",
      "Sky Blue": "#dc55b4",
      "Periwinkle Sunset": "#d3906f",
    },
    Boardwalk: {
      Red: "#e64d63",
      Blue: "#2498b9",
      Purple: "#422c74",
      Pink: "#e66aa3",
      Tan: "#947c4f",
      Black: "#383f3f",
    },
    "Derby Core": {
      Red: "#d33333",
      Peach: "#fcb797",
      "Fluorescent Orange": "#ff4e3b",
      "Carrot Orange": "#f48746",
      "Sunflower Yellow": "#ffd060",
      "Lemon Yellow": "#fbe97f",
      "Olive Green": "#9baf5a",
      "Lime Green": "#accd42",
      "Honeydew Green": "#bbf3da",
      "Aqua Spray Teal": "#6ca8b2",
      Teal: "#005a64",
      "Pool Blue": "#3688ba",
      "Grape Purple": "#9d43a7",
      "Periwinkle Purple": "#acb8d2",
      "Hot Magenta": "#fc267c",
      "Hot Pink": "#f25987",
      "Pink Cotton Candy": "#ffbfc7",
      Pomegranate: "#773d50",
      "Coffee Latte Brown": "#b58962",
      Tan: "#d1ab87",
      White: "#f0ebe8",
      "Slate Gray": "#3d414b",
    },
    Impala: {
      "Living Coral": "#fcab91",
      Aqua: "#ee9da9",
      "Voltage Green": "#f5e567",
      Purple: "#598997",
      Pink: "#e3c440",
      White: "#77cfcd",
      Black: "#383836",
    },
    Moxi: {
      Oyster: "#e5c39c",
      Black: "#3d3d3d",
    },
  },
  Wheels: {
    "Beach Bunny": {
      Watermelon: "#04be2e",
      "Peach Blanket": "#7b5ea0",
      "Strawberry Lemonade": "#e5757a",
      "Sky Blue": "#9e1152",
      "Periwinkle Sunset": "#ce8250",
    },
    Boardwalk: {
      Red: "#c90100",
      Yellow: "#dfcf27",
      Blue: "#78dae0",
      Pink: "#e800a6",
      Purple: "#710e96",
      Black: "#020407",
    },
    "Fame Artistic": {
      "Clear Red": "#af0023",
      "Clear Blue": "#01a7db",
      "Clear Purple": "#402a7a",
      "Clear Pink": "#a4069b",
    },
    Fundae: {
      "Bubble Gum": "#fec1dc",
      "Creme-de-Menthe": "#82c8ce",
      "Birthday Cake": "#76c4eb",
      Lavender: "#bcb4d8",
    },
    Gummy: {
      Cherry: "#7b1417",
      Clementine: "#dd743f",
      Pineapple: "#eedd71",
      Honeydew: "#b3da8f",
      Seafoam: "#d0ebca",
      Lavender: "#a4a2da",
      Pink: "#f5d2e9",
      Smoke: "#6c7071",
    },
    Impala: {
      "Living Coral": "#f4896b",
      "Voltage Green": "#f3e753",
      Aqua: "#47c0b9",
      Purple: "#ab96c4",
      Pink: "#f1bbb7",
      White: "#ec9ca6",
      Black: "#36383e",
    },
    Radar: {
      Donut: "#ffb988",
    },
    "Radar 57": {
      Red: "#de3740",
      Yellow: "#f5dc33",
      "Clear Blue": "#98d3fc",
      Blue: "#002e75",
    },
    "Radar 62": {
      Pink: "#df5166",
      "Clear Yellow": "#ddd550",
      "Clear Green": "#39cfba",
      Teal: "#4194ac",
      White: "#e6eaee",
    },
    "Radar 65": {
      "Clear Red": "#d41813",
      "Lime Green": "#88c45e",
      Blue: "#64aeec",
      Purple: "#af3b90",
      Clear: "#fbfcfc",
      Black: "#0b0d1a",
    },
    "Sonar Zen": {
      Red: "#fe5831",
      Orange: "#ff7c22",
      Yellow: "#ffde32",
      Green: "#6ce875",
      Blue: "#019be5",
      Purple: "#b2159e",
      Pink: "#fe6b83",
      Black: "#2c292a",
    },
    "Rollerbones Team": {
      Green: "#5cdd00",
      Purple: "#572b81",
      Pink: "#fb006a",
      White: "#ecede8",
      Black: "#1b1b1b",
    },
    Trick: {
      Orange: "#eab381",
      Green: "#c1ce63",
    },
  },
  Toestop: {
    "Break Petals": {
      "Carnation Pink": "#ffcada",
      "Yellow Daisy": "#febb0c",
      "Red Hibiscus": "#f54b4b",
      "Violet Forget-Me-Not": "#856ed3",
    },
    Chaya: {
      Red: "#f33e56",
      Orange: "#f05e32",
      Yellow: "#d8ed71",
      Blue: "#57cec1",
      Pink: "#ff66ae",
      Natural: "#ecc791",
    },
    Gumball: {
      Gumball: "#e6d3b6",
    },
    Impala: {
      "Living Coral": "#f4896b",
      "Voltage Green": "#eee339",
      Aqua: "#47c0b9",
      Purple: "#d6c2db",
      Pink: "#e4bebd",
      White: "#ed9caa",
      Black: "#71726f",
    },
    Powerdyne: {
      Black: "#302e38",
      Gray: "#757880",
    },
    Rx: {
      Red: "#d3302f",
      Yellow: "#f6ea1e",
      Green: "#58b94b",
      "Light Blue": "#9ecdda",
      Blue: "#549dd0",
      Purple: "#724b8b",
      Pink: "#ec4e73",
      Black: "#383232",
      Natural: "#b7a468",
    },
  },
  Eyelets: {
    "Beach Bunny": {
      Metal: "#d3d2dd",
    },
    Boardwalk: {
      Red: "#b1686d",
      Blue: "#7bbece",
      Purple: "#a087b4",
      Pink: "#d07394",
      Tan: "#a0724f",
      Black: "#848b8e",
    },
    Lolly: {
      Oyster: "#fefae6",
      Black: "#4c4c4c",
    },
    Impala: {
      "Living Coral": "#f5af8c",
      "Voltage Green": "#c9be0a",
      Aqua: "#f97087",
      Purple: "#dadbdd",
      Pink: "#e0e5e1",
      White: "#e3e4df",
      Black: "#070506",
    },
  },
  Sole: {
    "Beach Bunny": {
      Brown: "#784f3b",
    },
    Boardwalk: {
      Brown: "#735040",
      Gray: "#9ea59e",
      Black: "#32373a",
    },
    Lolly: {
      Brown: "#aa6742",
      Black: "#3f3f3f",
    },
    Impala: {
      "Voltage Green": "#c1bb35",
      Default: "#ac7f5c",
      Black: "#343434",
    },
  },
  Plate: {
    "Beach Bunny": {
      Metal: "#c3bfca",
    },
    Boardwalk: {
      Default: "#5a554f",
    },
    Powerdyne: {
      Black: "#39373a",
    },
  },
};

export default options;
